import { errorReporting } from '@shared/error-reporting/ErrorReporting.browser.ts';
import type { ErrorReporting } from '@shared/error-reporting/ErrorReporting.ts';
import { log } from '@shared/log.browser.ts';

export function createApmErrorHandler(
    scope: string,
    reporter: ErrorReporting,
): (error: unknown, reset: () => void) => void {
    return async function onerror(error: unknown, _reset: () => void) {
        log.scope(scope).error(error);
        reporter.report({ error, type: scope });
    };
}

export const createApmErrorHandlerBrowser = (scope: string) => createApmErrorHandler(scope, errorReporting);
